import React, { FC, ReactNode } from 'react';
import { MemberCareer, MembersPopupProps } from '@/pages/CareersPage/CareersPage.types';
import CareersPopup from '@/pages/CareersPage/components/popups/CareersPopup/CareersPopup';
import key from 'weak-key';
import classNames from 'classnames';
import styles from './MembersPopup.module.scss';

const MembersPopup: FC<MembersPopupProps> = ({
  title, backgroundImage, members, popupKey,
}) => {
  const renderMember = (member: MemberCareer): ReactNode => {
    const {
      linkedInUrl, photoUrl, photoColor, profession, fullName,
    } = member;

    return (
      <div key={key(member)} className={styles.member}>
        <div className={classNames(styles.photoContainer, styles[`photoContainer-${photoColor}`])}>
          {!!photoUrl && <img alt={fullName} className={styles.photo} src={photoUrl} />}
        </div>
        <div className={styles.textContainer}>
          {!!linkedInUrl && <a className={styles.linkedInLink} href={linkedInUrl}>{fullName}</a>}
          <div className={styles.jobTitle}>{profession}</div>
        </div>
      </div>
    );
  };

  return (
    <CareersPopup backgroundImage={backgroundImage} popupKey={popupKey} title={title}>
      <div className={styles.container}>
        {members.map((member) => renderMember(member))}
      </div>
    </CareersPopup>
  );
};
MembersPopup.displayName = 'MembersPopup';

export default MembersPopup;
